const siteConfig = {
  name: 'SupplySense 360: Empowering organizations to streamline their global supply chain operations',
  alt_name: 'SupplySense 360',
  description:
    'A SaaS platform that helps organizations track, manage, and optimize their global shipping operations',
  url: process.env.NEXT_PUBLIC_DOMAIN,
  ogImage: '',
  loading_bar_color: '#ADD8E6',
  links: {
    linkedin: 'https://www.linkedin.com/company/transport-analytics-llc'
  },
  seo_title: 'SupplySense 360 | Supply Chain Intelligence, Delivered',
  seo_description:
    'Transform your supply chain with real-time tracking, automated tools, inventory control, and market insights for smarter shipping decisions.',
    ga4_measurement_id: process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID,
};

export default siteConfig;
